import SwiperCore, { Autoplay, Navigation } from 'swiper';
import Swiper from 'swiper';

export function dataBaseSlider() {
  const $slider = $('.data-base-slider');
  if (!$slider || !$slider.length) return;

  SwiperCore.use([Autoplay, Navigation]);

  const swiper = new Swiper('.data-base-slider', {
    navigation: {
      nextEl: '.data-base-slider-next',
      prevEl: '.data-base-slider-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      767: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
}
